import AppContext from '@lightspeed-invoicing/core-client/frontend/app/Context';
import { defineMessages } from 'react-intl';
const messages = defineMessages({
    "custom_value_filters": {
        id: 'invoice.listing.custom_value_filters',
        defaultMessage: 'Custom value filters',
    },
})


export const getCustomFilters = function (context, objectType) {
    var newFilters = [{ section: context.intl?.formatMessage(messages["custom_value_filters"]), }]
    var definitions = AppContext.filtersDefinitions
    const containsDefinition = (definition, objectType) => {
        if (!definition.attributes.availableFrom) {
            return true
        }

        if (definition.attributes.availableFrom && definition.attributes.availableFrom.includes(objectType)) {
            return true
        }

        return false
    }
    var i = 60

    if (definitions && definitions !== null && definitions.length > 0) {
        definitions.forEach(elem => {
            if (containsDefinition(elem, objectType)) {
                var auxFilter = {}
                if (elem && (elem.attributes.fieldType === 'text' || elem.attributes.fieldType === 'multi-line-text')) {
                    auxFilter = {
                        nameId: "custom" + i,
                        label: elem.attributes.name,
                        elementSubtype: 'custom-values',
                        id: elem.id,
                        filterMatch: 'customValues.value',
                        filterMatchId: 'customValues.id',
                        filterPath: 'customValues',
                        type: 'text',
                        initialValue: '',
                        initialSelect: 'is'
                    }
                    newFilters.push(auxFilter)
                }
                if (elem && (elem.attributes.fieldType === 'date')) {
                    auxFilter = {
                        nameId: "custom" + i,
                        label: elem.attributes.name,
                        elementSubtype: 'custom-values',
                        id: elem.id,
                        filterMatchId: 'customValues.id',
                        filterMatch: 'customValues.valueDate',
                        filterPath: 'customValues',
                        type: 'date',
                        initialValue: { startDate: null, endDate: null },
                        initialSelect: 'is'
                    }
                    newFilters.push(auxFilter)
                }
                if (elem && (elem.attributes.fieldType === 'single-choice')) {
                    let options = []
                    let j = 0
                    if (elem.attributes.metadata) {
                        elem.attributes.metadata.forEach(value => {
                            let aux = { value: value, label: value }
                            options.push(aux)
                            j = j + 1
                        })
                    }

                    auxFilter = {
                        nameId: "custom" + i,
                        label: elem.attributes.name,
                        elementSubtype: 'custom-values',
                        id: elem.id,
                        filterMatchId: 'customValues.id',
                        filterMatch: 'customValues.value',
                        filterPath: 'customValues',
                        options: options,
                        type: 'custom-select',
                        initialValue: [],
                        initialSelect: 'isOneOf'
                    }
                    newFilters.push(auxFilter)
                }
            }
            i = i + 1
        })
    }

    if (newFilters.length == 1) {
        return []
    }

    return (newFilters)
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/customFilters.jsx